import { render, staticRenderFns } from "./roleTree.vue?vue&type=template&id=01a6c34d&scoped=true"
import script from "./roleTree.vue?vue&type=script&lang=js"
export * from "./roleTree.vue?vue&type=script&lang=js"
import style0 from "./roleTree.vue?vue&type=style&index=0&id=01a6c34d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a6c34d",
  null
  
)

export default component.exports